/**
 * Farbtreppe für Stufen-Felder OHNE eigene Legende im Hilfefenster
 * (Konsistenz, Substanzvolumen, Festigkeit, Fdwz-Häufung).
 *
 * Grau von weiß nach dunkel, gleichmäßig verteilt — dieselben Endpunkte wie
 * die Skelett-Reihe, damit die Spalten zusammenpassen. Die Farbe sagt nur
 * „mehr" oder „weniger", nichts Fachliches; wo ein Hilfefenster eine eigene
 * Legende führt (Humus, Skelett, Karbonat, Lagerungsdichte, Zersetzungsgrad),
 * gilt DIE, nicht diese Treppe.
 */
const HELL: [number, number, number] = [255, 255, 255];
const DUNKEL: [number, number, number] = [78, 91, 99]; // #4e5b63, das Ende der Skelett-Reihe

/** `anzahl` Farben von weiß (erste) bis dunkelgrau (letzte); bei 1 nur weiß. */
export function grauTreppe(anzahl: number): string[] {
	if (anzahl <= 0) return [];
	if (anzahl === 1) return [hex(HELL)];
	const farben: string[] = [];
	for (let i = 0; i < anzahl; i++) {
		const t = i / (anzahl - 1);
		farben.push(hex([0, 1, 2].map(k => Math.round(HELL[k] + (DUNKEL[k] - HELL[k]) * t)) as [number, number, number]));
	}
	return farben;
}

function hex(rgb: [number, number, number]): string {
	return '#' + rgb.map(k => k.toString(16).padStart(2, '0')).join('');
}
